const backendDomain = process.env.REACT_APP_BACKEND_URL

const SummaryApi = {
    logIn:{
        url: `${backendDomain}/api/login`,
        method: "post"
    },
    getAdminUsers:{
        url : `${backendDomain}/api/get-admins`,
        method: "get"
    },
    addAdminUser:{
        url : `${backendDomain}/api/add-admins`,
        method: "post"
    },
    getManagerUsers : {
        url : `${backendDomain}/api/get-managers`,
        method: "get"
    },
    addManagerUser: {
        url : `${backendDomain}/api/add-managers`,
        method: "post"
    },
    getTechnicianUsers: {
        url : `${backendDomain}/api/get-technicians`,
        method: "get"
    },
    addTechnicianUser: {
        url : `${backendDomain}/api/add-technicians`,
        method: "post" 
    },
    getBranches: {
        url : `${backendDomain}/api/get-branches`,
        method: "get" 
    },
      addBranch: {
        url : `${backendDomain}/api/add-branches`,
        method: "post" 
    },
    updateUserStatus: {
        url : `${backendDomain}/api/user-status`,
        method: "post"
    },
    getAllLeads: {
        url : `${backendDomain}/api/get-all-leads`,
        method: "get"
    },
    getLead :{
        url: `${backendDomain}/api/get-single-lead`,
        method: "get"
    },
    createLead : {
        url : `${backendDomain}/api/create-Lead`,
        method: "post"
    },
    updateLead: {
        url: `${backendDomain}/api/update-lead`,
        method: "post"
    },
    addRemark: {
        url: `${backendDomain}/api/lead-remarks`,
        method: "post"
    },
    convertToCustomer: {
        url : `${backendDomain}/api/lead-convert`,
        method: "post"
    },
    convertToDealer: {
        url : `${backendDomain}/api/lead-convert-dealer`,
        method: "post"
    },
    convertToDistributor: {
        url : `${backendDomain}/api/lead-convert-distributor`,
        method: "post"
    },
    convertToExistingCustomer: {
        url : `${backendDomain}/api/lead-convert-existing-customer`,
        method: "post"
    },
    search : {
        url : `${backendDomain}/api/search`,
        method: "get"
    },
    getAllCustomers : {
        url : `${backendDomain}/api/get-all-customers`,
        method: "get"
    },
    getCustomer: {
        url : `${backendDomain}/api/get-single-customer`,
        method: "get"
    },
    createCustomer :{
        url : `${backendDomain}/api/create-customer`,
        method: "post"
    },
    updateCustomer: {
        url : `${backendDomain}/api/update-customer`,
        method: "post"
    },
    checkDuplicateContactPerson: {
        url : `${backendDomain}/api/check-duplicate-contact-person`,
        method: "get"
    },
    verifyPassword: {
        url : `${backendDomain}/api/verify-password`,
        method: "post"
    },
    addOldProject: {
        url: `${backendDomain}/api/add-old-project`,
        method: "post"
    },
    getAllInventoryItems: {
        url : `${backendDomain}/api/get-all-inventory`,
        method: "get"
    },
    getInventoryItemById: {
        url: `${backendDomain}/api/get-single-inventory`,
        method: "get"
    },
    addInventoryItem: {
        url : `${backendDomain}/api/create-inventory`,
        method: "post"
    },
    updateInventoryItem: {
        url : `${backendDomain}/api/update-inventory`,
        method: "post"
    },
    addInventoryStock: {
        url : `${backendDomain}/api/add-stock`,
        method: "post"
    },
    deleteInventoryItem: {
        url : `${backendDomain}/api/delete-inventory`,
        method: "post"
    },
    getInventoryByType: {
        url : `${backendDomain}/api/inventory-by-type`,
        method: "get"
    },
    checkSerialNumber: {
        url: `${backendDomain}/api/check-serial`,
        method: "get"
    },
    getStockHistory: {
        url: `${backendDomain}/api/stock-history`,
        method: "get"
    },
    getInventoryCurrentStock: {
        url: `${backendDomain}/api/inventory-current-stock`,
        method: "get"
    },
    getManagerTechnician: {
        url : `${backendDomain}/api/manager-get-technician`,
        method: "get"
    },
    addManagerTechnician: {
        url: `${backendDomain}/api/manager-add-technician`,
        method: "post"
    },
    getUser: {
        url: `${backendDomain}/api/get-user`,
        method: "get"
      },
      updateUser: {
        url: `${backendDomain}/api/update-user`,
        method: "post"
      },
      deleteUser: {
        url: `${backendDomain}/api/delete-user`,
        method: "delete"
      },
      checkManagerStatus: {
        url : `${backendDomain}/api/manager-status`,
        method: "get"
      },
      getNewBranchManagers: {
        url : `${backendDomain}/api/new-managers`,
        method: "get"
      },
      initiateTransfer: {
        url : `${backendDomain}/api/initiate-transfer`,
        method: "post"
      },
      acceptTransfer: {
        url : `${backendDomain}/api/accept-transfer`,
        method: "post"
      },
      rejectTransfer: {
        url : `${backendDomain}/api/reject-transfer`,
        method: "post"
      },
      getRejectedTransfers: {
        url: `${backendDomain}/api/get-rejected-transfers`,
        method: "get"
      },
      createWorkOrder: {
        url : `${backendDomain}/api/create-work-orders`,
        method: "post"
      },
      addComplaint: {
        url : `${backendDomain}/api/add-complaint`,
        method: "post"
      },
      getWorkOrders: {
        url: `${backendDomain}/api/get-work-orders`,
        method: "get"
      },
      assignTechnician: {
        url : `${backendDomain}/api/assign-technician`,
        method: "post"
      },
      assignInventoryToTechnician: {
        url: `${backendDomain}/api/assign-inventory-technician`,
        method: "post"
      },
      getTechnicianInventory:{
        url : `${backendDomain}/api/get-technician-inventory`,
        method: "get"
      },
      getTechnicianWorkOrders: {
        url : `${backendDomain}/api/technician-work-orders`,
        method: "get"
      },
      updateWorkOrderStatus: {
        url : `${backendDomain}/api/update-work-status`,
        method: "post"
      },
      getTechnicianActiveProject: {
        url : `${backendDomain}/api/technician-active-projects`,
        method: "get"
      },
      createWorkOrderBill: {
        url : `${backendDomain}/api/create-bill`,
        method: "post"
      },
      confirmWorkOrderBill: {
        url : `${backendDomain}/api/confirm-order-bill`,
        method: "post"
      },
      getBillHistory: {
        url : `${backendDomain}/api/history`,
        method: "get"
      },
      getBillsByWorkOrder: {
        url : `${backendDomain}/api/workorder`,
        method: "get"
      },
      completeWorkOrder : {
        url : `${backendDomain}/api/complete-work-order`,
        method: "post"
      },
      getWorkOrderDetails: {
        url: `${backendDomain}/api/get-work-order-details`,
        method: "get"
      },
      returnInventoryToManager: {
        url : `${backendDomain}/api/return-inventory`,
        method: "post"
      },
      getTransferHistory: {
        url : `${backendDomain}/api/get-transfer-history`,
        method: "get"
      },
      getManagerProjects: {
        url : `${backendDomain}/api/get-manager-projects`,
        method: "get"
      },
      getManagerFinancialSummary: {
        url: `${backendDomain}/api/manager/financial-summary`,
        method: "get"
      },
      getAdminFinancialSummary: {
        url: `${backendDomain}/api/admin/financial-summary`,
        method: "get"
      },
      getBranchBalanceOverview: {
        url: `${backendDomain}/api/admin/branch-balance-overview`,
        method: "get"
      },
      getManagerBalanceOverview: {
        url: `${backendDomain}/api/manager/balance-overview`,
        method: "get"
      },
      getAvailableMonths: {
        url: `${backendDomain}/api/get-available-months`,
        method: "get"
      },
      approveWorkOrder: {
        url : `${backendDomain}/api/approve-order`,
        method: "post"
      },
      cancelWorkOrder: {
        url : `${backendDomain}/api/cancel-work-order`,
        method: "post"
      },
      addManagerInstruction: {
        url : `${backendDomain}/api/add-manager-instruction`,
        method: "post"
      },
      rejectBill: {
        url : `${backendDomain}/api/reject-bill`,
        method: "post"
      },
      getBillDetails:{
        url : `${backendDomain}/api/get-bill-details`,
        method: "get"
      },
      getTechnicianProjects: {
        url : `${backendDomain}/api/get-technician-projects`,
        method: "get"
      },
      addWorkOrderRemark:{
        url : `${backendDomain}/api/remark-add`,
        method: "post"
      },
      acceptTechnicianProjectTransfer: {
        url : `${backendDomain}/api/accept-technician-project-transfer`,
        method: "post"
      },
      rejectTechnicianProjectTransfer: {
        url : `${backendDomain}/api/reject-technician-project-transfer`,
        method: "post"
      },
      closeProject: {
        url : `${backendDomain}/api/close-project`,
        method: "post"
      },
      getReturnedInventory: {
        url: `${backendDomain}/api/get-returned-inventory`,
        method: "get"
      },
      confirmReturnedInventory:{
        url : `${backendDomain}/api/confirm-returned-inventory`,
        method: "post"
      },
      rejectReturnedInventory: {
        url: `${backendDomain}/api/reject-returned-inventory`,
        method: "post"
      },
      getTechnicianReturnRequests: {
        url: `${backendDomain}/api/get-technician-return-requests`,
        method: "get"
      },
      getSerialNumberDetails : {
        url: `${backendDomain}/api/serial-number-detail`,
        method: "get"
      },
      updateUsedSerialNumbers: {
        url : `${backendDomain}/api/update-serial-status`,
        method: "post"
      },
      registerWarrantyReplacement : {
        url :  `${backendDomain}/api/register-replacement`,
        method: "post"
      },
      getAllWarrantyReplacements :{
        url : `${backendDomain}/api/get-replacements`,
        method: "get"
      },
      completeWarrantyReplacement : {
        url : `${backendDomain}/api/complete-replacement`,
        method: "post"
      },
      getTechnicianInventoryHistory:{
        url : `${backendDomain}/api/get-inventory-history`,
        method: "get"
      },
      getManagerById: {
        url: `${backendDomain}/api/get-manager-detail`,
        method: "get"
      },
      changePassword: {
        url : `${backendDomain}/api/change-password`,
        method: "post"
      },
      adminChangePassword: {
        url: `${backendDomain}/api/admin-change-password`,
        method: "post"
      },
      getReplacementHistory: {
        url: `${backendDomain}/api/serial-number-history`,
        method: "get"
      },
      checkWarrantyStatus: {
        url: `${backendDomain}/api/check-warranty-status`,
        method: "get"
      },
      findByReplacementSerial: {
         url: `${backendDomain}/api/replaced-serial-number`,
        method: "get"
      },
      updateWarrantyClaim: {
        url : `${backendDomain}/api/warranty-claim`,
        method: "post"
      },
      resetSystem: {
        url: `${backendDomain}/api/reset-system`,
        method: "post"
      },
      
      // Dealer APIs
      createDealer: {
        url: `${backendDomain}/api/create-dealer`,
        method: "post"
      },
      getAllDealers: {
        url: `${backendDomain}/api/get-all-dealers`,
        method: "get"
      },
      getDealer: {
        url: `${backendDomain}/api/get-dealer`,
        method: "get"
      },
      updateDealer: {
        url: `${backendDomain}/api/update-dealer`,
        method: "post"
      },
      addDealerRemark: {
        url: `${backendDomain}/api/dealer-remarks`,
        method: "post"
      },
      
      // Distributor APIs
      createDistributor: {
        url: `${backendDomain}/api/create-distributor`,
        method: "post"
      },
      getAllDistributors: {
        url: `${backendDomain}/api/get-all-distributors`,
        method: "get"
      },
      getDistributor: {
        url: `${backendDomain}/api/get-distributor`,
        method: "get"
      },
      updateDistributor: {
        url: `${backendDomain}/api/update-distributor`,
        method: "post"
      },
      addDistributorRemark: {
        url: `${backendDomain}/api/distributor-remarks`,
        method: "post"
      },
      
      // Sales APIs
      createSalesBill: {
        url: `${backendDomain}/api/create-sales-bill`,
        method: "post"
      },
      getSalesBills: {
        url: `${backendDomain}/api/get-sales-bills`,
        method: "get"
      },
      getBillDetailsById: {
        url: `${backendDomain}/api/get-bill-details`,
        method: "get"
      },
      processPayment: {
        url: `${backendDomain}/api/process-payment`,
        method: "post"
      },
      generateQRCode: {
        url: `${backendDomain}/api/generate-qr`,
        method: "get"
      },
      getDealerBills: {
        url: `${backendDomain}/api/get-dealer-bills`,
        method: "get"
      },
      getDistributorBills: {
        url: `${backendDomain}/api/get-distributor-bills`,
        method: "get"
      },
      processBulkPayment: {
        url: `${backendDomain}/api/process-bulk-payment`,
        method: "post"
      },

      // Transaction History API
      getTransactionHistory: {
        url: `${backendDomain}/api/transaction-history`,
        method: "get"
      },
      
      // Customer billing APIs
      getCustomerBills: {
        url: `${backendDomain}/api/get-customer-bills`,
        method: "get"
      },
      createCustomerBill: {
        url: `${backendDomain}/api/create-customer-bill`,
        method: "post"
      },
      processCustomerBulkPayment: {
        url: `${backendDomain}/api/process-customer-bulk-payment`,
        method: "post"
      },

      // Bank Account APIs (Admin only)
      getBankAccounts: {
        url: `${backendDomain}/api/get-bank-accounts`,
        method: "get"
      },
      addBankAccount: {
        url: `${backendDomain}/api/add-bank-account`,
        method: "post"
      },
      updateBankAccount: {
        url: `${backendDomain}/api/update-bank-account`,
        method: "put"
      },
      deleteBankAccount: {
        url: `${backendDomain}/api/delete-bank-account`,
        method: "delete"
      },

      // Profile Picture APIs
      uploadProfilePicture: {
        url: `${backendDomain}/api/upload-profile-picture`,
        method: "post"
      },
    deleteProfilePicture: {
        url: `${backendDomain}/api/delete-profile-picture`,
        method: "delete"
      },
      registerNotificationToken: {
        url: `${backendDomain}/api/notifications/token`,
        method: "post"
      },
      removeNotificationToken: {
        url: `${backendDomain}/api/notifications/token`,
        method: "delete"
      },

      // Inventory Export/Import APIs
      exportInventory: {
        url: `${backendDomain}/api/export-inventory`,
        method: "get"
      },
      importInventory: {
        url: `${backendDomain}/api/import-inventory`,
        method: "post"
      },

      // Software Backup/Restore APIs (Admin only)
      exportFullBackup: {
        url: `${backendDomain}/api/export-full-backup`,
        method: "get"
      },
      importFullBackup: {
        url: `${backendDomain}/api/import-full-backup`,
        method: "post"
      }
}

export default SummaryApi;
